import { render, staticRenderFns } from "./createTask.vue?vue&type=template&id=f9f7b5d2&scoped=true&"
import script from "./createTask.vue?vue&type=script&lang=js&"
export * from "./createTask.vue?vue&type=script&lang=js&"
import style0 from "./createTask.vue?vue&type=style&index=0&id=f9f7b5d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f7b5d2",
  null
  
)

export default component.exports